<template>
  <div class="ignore-box">
    <div class="panel">
      <div style="font: 4ex bold;text-align: center;">{{`${curArea} Alert Ignore List`.toUpperCase()}}</div>
      <div style="margin:20px">
        <el-dropdown @command="dropdownFn">
          <div class="btn btn-default">
            {{typeMap[activeType]}}<i class="el-icon-arrow-down el-icon--right"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="ALL">{{typeMap['ALL']}}</el-dropdown-item>
            <el-dropdown-item command="IB">{{typeMap['IB']}}</el-dropdown-item>
            <el-dropdown-item command="IB_SUB">{{typeMap['IB_SUB']}}</el-dropdown-item>
            <el-dropdown-item command="SL">{{typeMap['SL']}}</el-dropdown-item>
            <el-dropdown-item command="SL_SUB">{{typeMap['SL_SUB']}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="btn btn-default" @click="refresh"><i class="glyphicon glyphicon-refresh"></i>{{multiLanguage.refresh}}</div>
        <div class="btn btn-default" @click="addItem"><i class="glyphicon glyphicon-plus"></i>{{multiLanguage.add}}</div>
        <div style="display:inline;margin-left:50px">
          <span>{{multiLanguage.node_id}}:</span>
          <el-input style="width:200px;" v-model="searchVal"><el-button slot="append" icon="el-icon-search" @click="search"></el-button></el-input>
        </div>
      </div>
      <el-table :data="trData" border size="small" v-loading="loading" element-loading-spinner="el-icon-loading">
        <el-table-column prop='label' :label='multiLanguage.type'></el-table-column>
        <el-table-column prop='node_id' :label='multiLanguage.node_id'></el-table-column>
        <el-table-column fixed="right" :label="multiLanguage.operate">
          <template slot-scope="scope">
            <el-button @click="deleteItem(scope.row)" type="text" size="small"><span>{{multiLanguage.delete}}</span></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :title="multiLanguage.add" :visible.sync="dialogFormVisible" width="600px">
      <el-row>
        <el-col :span="6"><span style="float:right;line-height=30px;margin:10px">{{multiLanguage.type}}</span></el-col>
        <el-col :span="9"><el-select v-model="addData.type" placeholder="Select">
          <el-option :label="typeMap['IB']" value="IB"></el-option>
          <el-option :label="typeMap['IB_SUB']" value="IB_SUB"></el-option>
          <el-option :label="typeMap['SL']" value="SL"></el-option>
          <el-option :label="typeMap['SL_SUB']" value="SL_SUB"></el-option>
        </el-select></el-col>
      </el-row><br/>
      <el-row>
        <el-col :span="6"><span style="float:right;line-height=30px;margin:10px">{{multiLanguage.node_id}}</span></el-col>
        <el-col :span="9"><el-input v-model="addData.node_id" autocomplete="off" style='float:left'></el-input></el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{multiLanguage.cancel}}</el-button>
        <el-button type="primary" @click="addCommit">{{multiLanguage.submit}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { URL_TOOL_ALERT_IGNORE2 } from "api/commissionApi";
import { Api } from "api/commissionEnv";
import noData from "components/noData"
const api = new Api();
export default {
  mixins: [ require("common/mixin/base.js").base({multiLanguage:"alertIgnore"}) ],
  props: {
    curArea: {
      type: String,
      default: ""
    }
  },
  data(){
    return {
      addData:{
        node_id:'',
        type:'',
      },
      loading: false,
      dialogFormVisible:false,
      activeType:'ALL',
      trData:[],
      searchVal:'',
    }
  },
  computed:{
    typeMap(){
      return this.multiLanguage.typeMap
    }
  },
  watch:{
    curArea(value){
      this.refresh()
    }
  },
  mounted(){
    this.refresh()
  },
  methods:{
    dropdownFn(e){
      this.activeType = e
      this.refresh()
    },
    async refresh(){
      this.loading = true
      let url = api.getUrl20(this.curArea, URL_TOOL_ALERT_IGNORE2) + '?searchVal='+this.searchVal;
      if(this.activeType != 'ALL') url += '&type='+this.activeType;
      const {
        data: { data }
      } = await this.$http.get(url);
      this.trData = data.map(it=>{
        it.label=this.typeMap[it.type]
        return it
      })
      this.loading = false
    },
    addItem(){
      this.addData.node_id = ''
      this.addData.type = ''
      this.dialogFormVisible = true
    },
    async deleteItem(item){
      let yes = confirm(this.multiLanguage.deleteTips);
      if(!yes) return;
      const url = api.getUrl20(this.curArea, URL_TOOL_ALERT_IGNORE2);
      const {
        data
      } = await this.$http.post(url,{node_id:item.node_id,type:item.type,operate:'delete'});
      this.refresh()
    },
    async addCommit(){
      if(!this.addData.node_id || !this.addData.type){
        alert(this.multiLanguage.submitTips)
        return
      }
      const url = api.getUrl20(this.curArea, URL_TOOL_ALERT_IGNORE2);
      const {
        data
      } = await this.$http.post(url,{node_id:this.addData.node_id,type:this.addData.type,operate:'add'});
      this.dialogFormVisible = false
      this.refresh()
    },
    search(){
      this.refresh()
    }
  }
};
</script>
<style scoped>
.ignore-box{
  margin-top: 20px;
  padding-bottom: 20px;
  padding: 20px;
}
/deep/ .el-table .cell{
  text-align: center;
}
/deep/ .el-table th{
  background-color: #f5f5f5;
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// AlertIgnore2.vue?04979828